import { createQueryKeys } from '@lukemorales/query-key-factory';
import { getIsUniqueUsernameQueryKey, isUniqueUsername } from 'ze-sdk';
export const userNameQuery = createQueryKeys('userName', {
    isUnique: (userName)=>({
            queryKey: userName ? getIsUniqueUsernameQueryKey({
                username: userName
            }) : [
                'userName',
                'isUnique',
                'missing'
            ],
            queryFn: async ()=>{
                if (!userName) {
                    return null;
                }
                const { value } = await isUniqueUsername({
                    username: userName
                });
                return value;
            }
        })
});
export async function useGetIsUniqueUserName(queryClient, username) {
    return queryClient.fetchQuery(userNameQuery.isUnique(username));
}
